module.exports = __webpack_public_path__ + "media/src/assets/Images/HomeIcon-42b772afe9a613edfc3838d38c2f83c4.svg";